module.exports = __webpack_public_path__ + "img/img-36.dd4a9595.png";